export class Storage {
    constructor(key, transforms) {
        this.key = key;
        this.transforms = transforms;
    }
    save(_data) {
        var _a;
        const data = Object.assign({}, _data);
        Object.entries((_a = this.transforms) !== null && _a !== void 0 ? _a : []).forEach(([key, [encode]]) => {
            if (data[key]) {
                data[key] = encode(data[key]);
            }
        });
        localStorage.setItem(this.key, JSON.stringify(data));
    }
    load() {
        var _a;
        const parsed = this.loadJson();
        if (!parsed) {
            return null;
        }
        Object.entries((_a = this.transforms) !== null && _a !== void 0 ? _a : []).forEach(([key, [, decode]]) => {
            if (parsed[key]) {
                parsed[key] = decode(parsed[key]);
            }
        });
        return parsed;
    }
    clear() {
        localStorage.removeItem(this.key);
    }
    loadJson() {
        try {
            return JSON.parse(localStorage.getItem(this.key));
        }
        catch (_a) {
            return null;
        }
    }
}
